export default {"src":"/bnb/_next/static/media/certora.f2bd76db.svg","height":20,"width":20};